//helper debounce function
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

class ProductSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    console.log('slider init');
    const swiperElement = this.querySelector('.swiper');
    if (swiperElement) {
      this.swiper = new Swiper(swiperElement, {
        spaceBetween: 5,
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        initialSlide: 0,
        mousewheel: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        // pagination: {
        //   el: '.swiper-pagination',
        //   clickable: true,
        // },
        // breakpoints: {
        //   768: {
        //     slidesPerView: 2,
        //   },
        //   1067: {
        //     slidesPerView: 2,
        //   },
        //   1068: {
        //     slidesPerView: 1,
        //   },
        //   1460: {
        //     slidesPerView: 2,
        //     centeredSlides: false,
        //   },
        //   1800: {
        //     slidesPerView: 2,
        //     centeredSlides: false,
        //   },
        //   2000: {
        //     slidesPerView: 4,
        //     centeredSlides: false,
        //   },
        //   2400: {
        //     slidesPerView: 4.5,
        //     centeredSlides: false,
        //   },
        // },
      });
    }
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy();
      this.swiper = null;
    }
  }
}

customElements.define('gallery-slider', ProductSlider);

class BundleSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.thumbsSwiper = null;
    this.prevButton = null;
    this.nextButton = null;
    this.prevButtonHandler = this.handlePrevButtonClick.bind(this);
    this.nextButtonHandler = this.handleNextButtonClick.bind(this);
  }

  connectedCallback() {
    this.initThumbs();
    this.initMainSlider();
    this.initCustomButtons();

    document.addEventListener('bundleSlider:changeSlide', this.handleSliderChange.bind(this));
  }

  initMainSlider() {
    const sliderElement = this.querySelector('.main-bundle-slider');
    if (sliderElement) {
      this.swiper = new Swiper(sliderElement, {
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        loop: false,
        slidesPerView: 1,
        initialSlide: 0,
        thumbs: {
          swiper: this.thumbsSwiper,
        },
        on: {
          init: () => {
            console.log('Swiper initialized');
          },
          slideChangeTransitionStart: () => {
            console.log('Active Index:', this.swiper.activeIndex);
            console.log('Is End:', this.swiper.isEnd);
            console.log('Is Beginning:', this.swiper.isBeginning);
            console.log('Total Slides:', this.swiper.slides.length);
          },
        },
      });
    }
  }

  initCustomButtons() {
    this.prevButton = this.querySelector('.swiper-button-prev');
    this.nextButton = this.querySelector('.swiper-button-next');

    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.prevButtonHandler);
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', this.nextButtonHandler);
    }
  }

  initThumbs() {
    const thumbsSliderElement = this.querySelector('.thumbs-slider');
    if (thumbsSliderElement) {
      this.thumbsSwiper = new Swiper(thumbsSliderElement, {
        spaceBetween: 15,
        slidesPerView: 'auto',
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });
    }
  }

  handlePrevButtonClick() {
    if (this.swiper.isBeginning) {
      this.swiper.slideTo(this.swiper.slides.length - 1);
    } else {
      this.swiper.slidePrev();
    }
  }

  handleNextButtonClick() {
    if (this.swiper.isEnd) {
      this.swiper.slideTo(0);
    } else {
      this.swiper.slideNext();
    }
  }

  handleSliderChange(event) {
    if (!event.detail) return;

    const index = event.detail.sliderIndex || 0;
    if (this.swiper && !this.swiper.isBeginning) {
      this.swiper.slideTo(index);
    }
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    if (this.thumbsSwiper) {
      this.thumbsSwiper.destroy(true, true);
      this.thumbsSwiper = null;
    }

    if (this.prevButton) {
      this.prevButton.removeEventListener('click', this.handlePrevButtonClick);
    }

    if (this.nextButton) {
      this.nextButton.removeEventListener('click', this.handleNextButtonClick);
    }

    document.removeEventListener('bundleSlider:changeSlide', this.handleSliderChange.bind(this));
  }
}

customElements.define('bundle-slider', BundleSlider);

class ImageCanvas extends HTMLElement {
  static CANVAS_WIDTH = 660;
  static CANVAS_HEIGHT = 680;
  static RENDER_OPTIONS = {
    'carry-on-medium': 'renderCarryOnMediumImages',
    'carry-on-medium-large': 'renderCarryOnMediumLargeImages',
    'carry-on-medium-large-underseat': 'renderCarryOnMediumLargeUnderseatImages',
    'carry-on-medium-large-cube': 'renderCarryOnMediumLargeCubeImages',
    'carry-on-large-backpack': 'renderCarryOnLargeBackpackImages',
    'carry-on-large': 'renderCarryOnLargeImages',
  };

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.renderOption = this.getAttribute('data-render');
    this.images = [];
    this.imageAttributes = ['image1', 'image2', 'image3', 'image4'];
    this.totalImages = parseInt(this.getAttribute('totalImages'), 10) || 2;
  }

  connectedCallback() {
    this.setupCanvas();
    this.loadImages();
  }

  static get observedAttributes() {
    return ['image1', 'image2', 'image3', 'image4'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      if (this.imageAttributes.includes(name)) {
        this.debounceDrawImage();
      }
    }
  }

  setupCanvas() {
    const canvas = document.createElement('canvas');
    canvas.width = ImageCanvas.CANVAS_WIDTH;
    canvas.height = ImageCanvas.CANVAS_HEIGHT;
    canvas.innerHTML = `<style>
      :host canvas {
        width: 100%;
      }
      @media (min-width:992px){
        :host canvas {
          width: calc(100% - 40px);
          margin-right: 40px;
        }
      }
     </style>`;
    this.shadowRoot.appendChild(canvas);
    this.ctx = canvas.getContext('2d');
  }

  loadImages() {
    const imagePromises = this.imageAttributes
      .slice(0, this.totalImages)
      .map((attr) => this.loadImage(this.getAttribute(attr)));

    Promise.all(imagePromises)
      .then((loadedImages) => {
        this.images = loadedImages;
        this.drawImages();
      })
      .catch((error) => {
        console.error(`Failed to load images: ${error}`);
      });
  }

  loadImage(url) {
    return new Promise((resolve, reject) => {
      if (!url) {
        reject(new Error('No Image URL provide'));
      }
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error(`Failed to load image: ${url}`));
      image.src = url;
    });
  }

  debounceDrawImage = debounce(() => {
    this.loadImages();
  }, 200);

  drawImages() {
    this.ctx.clearRect(0, 0, ImageCanvas.CANVAS_WIDTH, ImageCanvas.CANVAS_HEIGHT); // Clear previous drawings

    const renderFunction = this[ImageCanvas.RENDER_OPTIONS[this.renderOption]];
    console.log(renderFunction);
    if (typeof renderFunction === 'function') {
      renderFunction.call(this, this.images);
    } else {
      console.error(`Invalid render options: ${this.renderOption}`);
    }

    this.dispatchEvent(new CustomEvent('imageCanvas:update'));
  }

  renderCarryOnMediumImages([image1, image2]) {
    const image1Dimensions = this.imageDimension(image1, 350, 2, 3);
    const image2Dimensions = this.imageDimension(image2, 250, 8, 1.25);

    this.ctx.drawImage(image1, image1Dimensions.x, image1Dimensions.y, image1Dimensions.width, image1Dimensions.height);
    this.ctx.drawImage(image2, image2Dimensions.x, image2Dimensions.y, image2Dimensions.width, image2Dimensions.height);
  }

  renderCarryOnLargeBackpackImages([image1, image2, image3]) {
    const image1Dimensions = this.imageDimension(image1, 330, 2, 3);
    const image2Dimensions = this.imageDimension(image2, 200, 1.53, 1.4);
    const image3Dimensions = this.imageDimension(image3, 150, 1.55, 10);

    this.ctx.drawImage(image1, image1Dimensions.x, image1Dimensions.y, image1Dimensions.width, image1Dimensions.height);
    this.ctx.drawImage(image2, image2Dimensions.x, image2Dimensions.y, image2Dimensions.width, image2Dimensions.height);
    this.ctx.drawImage(image3, image3Dimensions.x, image3Dimensions.y, image3Dimensions.width, image3Dimensions.height);
  }

  renderCarryOnLargeImages([image1, image2]) {
    const image1Dimensions = this.imageDimension(image1, 350, 2, 3);
    const image2Dimensions = this.imageDimension(image2, 200, 1.53, 1.4);

    this.ctx.drawImage(image1, image1Dimensions.x, image1Dimensions.y, image1Dimensions.width, image1Dimensions.height);
    this.ctx.drawImage(image2, image2Dimensions.x, image2Dimensions.y, image2Dimensions.width, image2Dimensions.height);
  }

  renderCarryOnMediumLargeImages([image1, image2, image3]) {
    const image1Dimensions = this.imageDimension(image1, 390);
    const image2Dimensions = this.imageDimension(image2, 290, 1.05, 1.6);
    const image3Dimensions = this.imageDimension(image3, 250, 2, 0.99);

    this.ctx.drawImage(
      image1,
      image1Dimensions.x,
      image1Dimensions.y - image1Dimensions.y / 1.5,
      image1Dimensions.width,
      image1Dimensions.height
    );
    this.ctx.drawImage(image2, image2Dimensions.x, image2Dimensions.y, image2Dimensions.width, image2Dimensions.height);
    this.ctx.drawImage(image3, image3Dimensions.x, image3Dimensions.y, image3Dimensions.width, image3Dimensions.height);
  }

  renderCarryOnMediumLargeUnderseatImages([image1, image2, image3, image4]) {
    const image1Dimensions = this.imageDimension(image1, 390);
    const image2Dimensions = this.imageDimension(image2, 290, 1.05, 1.6);
    const image3Dimensions = this.imageDimension(image3, 250, 2, 0.99);
    const image4Dimensions = this.imageDimension(image4, 190, 1.2, 0.99);

    this.ctx.drawImage(
      image1,
      image1Dimensions.x,
      image1Dimensions.y - image1Dimensions.y / 1.5,
      image1Dimensions.width,
      image1Dimensions.height
    );
    this.ctx.drawImage(image2, image2Dimensions.x, image2Dimensions.y, image2Dimensions.width, image2Dimensions.height);
    this.ctx.drawImage(image3, image3Dimensions.x, image3Dimensions.y, image3Dimensions.width, image3Dimensions.height);
    this.ctx.drawImage(image4, image4Dimensions.x, image4Dimensions.y, image4Dimensions.width, image4Dimensions.height);
  }

  renderCarryOnMediumLargeCubeImages([image1, image2, image3, image4]) {
    const image1Dimensions = this.imageDimension(image1, 340, 4.2);
    const image2Dimensions = this.imageDimension(image2, 300, 1.09, 2.5);
    const image3Dimensions = this.imageDimension(image3, 200, 1.73, 1.5);
    const image4Dimensions = this.imageDimension(image4, 230, 9, 1.35);

    this.ctx.drawImage(
      image1,
      image1Dimensions.x,
      image1Dimensions.y - image1Dimensions.y / 1.5,
      image1Dimensions.width,
      image1Dimensions.height
    );
    this.ctx.drawImage(image2, image2Dimensions.x, image2Dimensions.y, image2Dimensions.width, image2Dimensions.height);
    this.ctx.drawImage(image4, image4Dimensions.x, image4Dimensions.y, image4Dimensions.width, image4Dimensions.height);
    this.ctx.drawImage(image3, image3Dimensions.x, image3Dimensions.y, image3Dimensions.width, image3Dimensions.height);
  }

  imageDimension(image, width, x = 2, y = 2) {
    const ratio = image.width / image.height;
    const newHeight = width / ratio;
    const dx = (ImageCanvas.CANVAS_WIDTH - width) / x;
    const dy = (ImageCanvas.CANVAS_HEIGHT - newHeight) / y;

    return {
      width,
      height: newHeight,
      x: dx,
      y: dy,
    };
  }
}

customElements.define('image-canvas', ImageCanvas);

class VariationsSiblings extends HTMLElement {
  constructor() {
    super();
    this.handleLabelClick = this.handleLabelClick.bind(this);
    this.updateCanvasContainer = this.updateCanvasContainer.bind(this);
    this.handleDispatchEvent = this.handleDispatchEvent.bind(this);
    this.button = document.querySelector('#AddToCart');
  }

  static activeVariants = {};

  static updateActiveVariant(type, id) {
    if (!type || !id) {
      console.error(`Invalid variant type or id. Type: ${type}, Id: ${id}`);
      return false;
    }
    VariationsSiblings.activeVariants[type] = id;
    return true;
  }

  static getActiveVariants() {
    return VariationsSiblings.activeVariants;
  }

  connectedCallback() {
    this.addEventListener('click', this.handleLabelClick);
    this.initializeActiveVariant();
    this.canvasEl = document.querySelector('image-canvas');
    this.canvasEl?.addEventListener('imageCanvas:update', this.updateCanvasContainer);

    document.addEventListener('variationsSiblings:update', this.handleDispatchEvent);

    this.handleInactiveLabel();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleLabelClick);
    this.canvasEl?.removeEventListener('imageCanvas:update', this.updateCanvasContainer);
  }
  handleInactiveLabel() {
    const fieldset = this.querySelector('.product-form__input label.active');
    if (!fieldset) {
      const label = this.querySelector('.product-form__input label:first-of-type');
      if (label) {
        label.classList.add('active');
        label.click();
      }
    }
  }

  initializeActiveVariant() {
    const activeLabel = this.querySelector('label.active');
    if (activeLabel) {
      const variantId = activeLabel.getAttribute('data-variant');
      const variantType = this.getAttribute('data-variant-type');
      VariationsSiblings.updateActiveVariant(variantType, variantId);
    }
  }

  handleDispatchEvent(e) {
    if (e.type !== 'variationsSiblings:update' && !e.detail) return false;

    const label = this.querySelector(`label#${e.detail.id}`);
    if (label) {
      this.updateLabel(label)
        .then(() => {
          // console.log('handle dispatch event');
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.button.classList.remove('active');
        });
    }
  }

  handleLabelClick(e) {
    const label = e.target.closest('label[data-index]');
    console.log(e.target, label);
    if (!label || !this.contains(label)) return false;

    this.updateLabel(label)
      .then(() => {
        document.dispatchEvent(
          new CustomEvent('productSetItem:update', {
            bubbles: true,
            detail: {
              id: label.getAttribute('id'),
            },
          })
        );
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.button.classList.remove('active');
      });
  }

  updateCartButton(text = 'Add to cart') {
    this.button.querySelector('.single-add-to-cart-button--text').setAttribute('data-content', text);
  }

  async updateLabel(label) {
    try {
      this.button.classList.add('active', 'disabled');

      const res = await fetch(`${label.getAttribute('data-product')}`);
      const { available, quantity } = await res.json();

      const siblingGroup = this;

      const currentActiveLabel = siblingGroup.querySelector('label.active');

      // Extract data from label (with more robust parsing)
      const color = label.getAttribute('title') || '';
      const index = parseInt(label.dataset.index, 10) || 1;
      const img = label.getAttribute(`image${index}`);
      const labelValue = siblingGroup.querySelector('.form__label__value');

      //update visual state
      currentActiveLabel?.classList.remove('active');
      label.classList.add('active');

      const variantId = label.getAttribute('data-variant');
      const variantType = this.getAttribute('data-variant-type');
      VariationsSiblings.updateActiveVariant(variantType, variantId);

      // console.log('updated active variants:', VariationsSiblings.getActiveVariants());

      if (labelValue) {
        labelValue.textContent = `: ${color}`;
      }

      if (img) {
        this.canvasEl.setAttribute(`image${index}`, img);
        const bundleSliderImg = document.querySelector(`#bundle-slider-${index} img`);
        const thumbImg = document.querySelector(`#thumb-img-${index}`);

        if (bundleSliderImg) {
          bundleSliderImg.setAttribute('srcset', img);
        }
        if (thumbImg) {
          thumbImg.setAttribute('src', img);
        }
      }

      document.dispatchEvent(
        new CustomEvent('bundleSlider:changeSlide', {
          bubbles: true,
          detail: {
            sliderIndex: index,
          },
        })
      );

      if (!available && quantity < 1) {
        this.updateCartButton('Sold out');
        return;
      }

      this.updateCartButton('Add to cart');
      this.button.classList.remove('disabled');
    } catch (e) {
      console.log(e);
      throw e;
    }

    return false;
  }

  updateCanvasContainer() {
    const originalCanvas = this.canvasEl.shadowRoot.querySelector('canvas');

    if (originalCanvas) {
      const dataUrl = originalCanvas.toDataURL();
      const thumbImg = document.querySelector(`#thumb-img-0`);
      if (thumbImg) {
        thumbImg.setAttribute('srcset', dataUrl);
      }
    }
  }
}

customElements.define('variations-siblings', VariationsSiblings);

class ProductSetItem extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector('img');
    this.url = this.querySelector('a.block');
    this.handleLabelEvent = this.handleLabelEvent.bind(this);
    this.handleDispatchEvent = this.handleDispatchEvent.bind(this);
    this.labels = Array.from(this.querySelectorAll('.bundle-product-siblings label'));
  }

  connectedCallback() {
    this.labels.forEach((label) => label.addEventListener('mouseenter', this.handleLabelEvent));
    document.addEventListener('productSetItem:update', this.handleDispatchEvent);
  }

  disconnectedCallback() {
    this.cleanup();
  }

  handleLabelEvent(e) {
    const target = e.currentTarget;
    if (!target) return;

    e.preventDefault();

    this.updateLabel(target);
    if (target.tagName.toLowerCase() === 'label') {
      document.dispatchEvent(
        new CustomEvent('variationsSiblings:update', {
          bubbles: true,
          detail: {
            id: target.dataset.id,
          },
        })
      );
    }
  }

  updateLabel(target) {
    try {
      const activeLabel = target.closest('.bundle-product-siblings').querySelector('label.active');
      const src = target.dataset['image'];
      const newUrl = target.dataset['url'];

      if (this.url && newUrl) {
        this.url.setAttribute('href', newUrl);
      }

      if (activeLabel) {
        activeLabel.classList.remove('active');
      }
      target.classList.add('active');

      if (this.image && src) {
        this.image.setAttribute('srcset', src);
      }
    } catch (error) {
      console.error('Error handling label event:', error);
    }
  }

  handleDispatchEvent(e) {
    if (e.type !== 'productSetItem:update' && !e.detail) return false;
    const id = e.detail.id;
    const target = this.querySelector(`label[data-id='${id}']`);
    if (target) {
      this.updateLabel(target);
    }
  }

  cleanup() {
    this.image = null;
    this.url = null;
    this.labels.forEach((label) => label.removeEventListener('mouseenter', this.handleLabelEvent));
    document.removeEventListener('productSetItem:update', this.handleDispatchEvent);
  }
}

customElements.define('product-set-item', ProductSetItem);

class BundleProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.button = this.querySelector('#AddToCart');
    this.onSubmit = this.onSubmit.bind(this);
  }

  connectedCallback() {
    this._bundle_group = this.form.querySelector('input[name="_bundle_group"]').value;
    this._bundle_variant = this.form.querySelector('input[name="_bundle_variant"]').value;
    this.button.addEventListener('click', this.onSubmit);
  }

  disconnectedCallback() {
    this.button.removeEventListener('click', this.onSubmit);
  }

  updateCartButton(text = 'Add to cart') {
    this.button.querySelector('.single-add-to-cart-button--text').setAttribute('data-content', text);
  }

  onSubmit(e) {
    e.preventDefault();
    this.button.classList.add('active');
    const variants = VariationsSiblings.getActiveVariants();
    const groupId = new Date().valueOf();
    const items = Object.values(variants).map((variant) => ({
      quantity: 1,
      id: variant,
      properties: {
        _bundleId: groupId,
        _bundle_variant: this._bundle_variant,
        _bundle_group: this._bundle_group,
      },
    }));
    const formData = {
      items,
    };

    fetch(`${window.location.pathname}?view=bundle-stock`)
      .then((response) => response.json())
      .then((variantsData) => {
        const inStock = Object.values(variants).every((variant) => {
          const data = variantsData[variant];
          return data && data.available && data.quantity > 0;
        });
        if (inStock) {
          console.log({ inStock });

          this.addCart(formData);
        } else {
          this.updateCartButton('Sold Out');
          this.button.classList.add('disabled');
          this.button.classList.remove('active');
          alert('Sorry, one or more products are out of stock currently');
        }
      })
      .catch((e) => console.error(e));
  }

  addCart(formData) {
    console.log(formData);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        this.openCartDrawer();
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.button.classList.remove('active');
      });
  }

  openCartDrawer() {
    const drawer = document.getElementById('Cart-Drawer');
    if (!drawer) {
      window.location = '/cart';
    }
    fetch('/cart?view=drawer')
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('#Cart-Drawer');
        const count = doc.querySelector('.thb-item-count').innerText;
        if (newCartDrawer) {
          drawer.innerHTML = newCartDrawer.innerHTML;
          drawer.classList.add('active');
          document.body.classList.add('open-cart');
          document.body.classList.add('open-cc');
          if (document.getElementById('Cart-Drawer').querySelector('.product-recommendations--full')) {
            document
              .getElementById('Cart-Drawer')
              .querySelector('.product-recommendations--full')
              .classList.add('active');
          }
          dispatchCustomEvent('cart-drawer:open');

          document.querySelector('#header .thb-item-count').innerText = count;
        } else {
          window.location = '/cart';
        }
      });
  }
}

if (!customElements.get('bundle-product-form')) {
  customElements.define('bundle-product-form', BundleProductForm);
}
